import React from 'react';
import { Link } from 'react-router-dom';

const RelatedArticlesTitles = ({ articles }) => {

    if (!Array.isArray(articles) || articles.length === 0) {
        return null;
    }
     
    return (
        <div className="mt-8 mb-8 border-t border-b" style={{borderColor: 'var(--border-color)'}}>
            {articles.map((article) => (
                <div key={article.id}>
                    <Link to={`/${article.pageUrl}`}>
                        <h3 className="mt-4 mb-4 font-semibold" style={{fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif', color: 'var(--text-color)', fontSize: '18px', lineHeight: '1.35em', fontWeight: '500'}}>{article.title}</h3>
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default RelatedArticlesTitles;